import { Routes, Route, Navigate } from "react-router-dom";
import routes from "./routes";
import { KnowledgebaseCustomizationProvider } from "../../../context/knowledgebaseCustomization";

export default function Knowledgebase() {
  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.items && route.items.length) {
        return getRoutes(route.items);
      }

      if (route.route) {
        return (
          <Route
            exact
            path={route.route}
            element={route.component}
            key={route.key}
          />
        );
      }

      return null;
    });

  return (
    <div>
      <KnowledgebaseCustomizationProvider>
        <Routes>{getRoutes(routes)}</Routes>
      </KnowledgebaseCustomizationProvider>
    </div>
  );
}
